<div class="d-flex flex-column flex-fill p-2 hide-scroll-bar"
	 [style.min-height]="hideFilters ? '300px' : 'calc(100vh - 150px)'"
	 [style.max-height]="hideFilters ? 'none' : 'calc(100vh - 150px)'"
	 style="border: 1px solid #ced4da; border-radius: 6px;">
	<div class="d-flex">
		<div>
			<slick-search-bar (onSearch)="onSearch($event)" [showAddButton]="false" [showEditButton]="false"></slick-search-bar>
		</div>
		<div *ngIf="!hideFilters" class="ms-2">
			<button type="button"
					class="btn btn-outline-primary"
					style="width: 80px; border-radius: 19px;"
					(click)="onNewPayment()">
				<i class="far fa-plus"></i>
				<span class="d-none d-xl-inline-block">&nbsp;New</span>
			</button>
		</div>
	</div>
	<div class="mt-2" [class.d-none]="hideFilters">
		<input type="checkbox"
			   [(ngModel)]="showUnappliedOnly"
			   (click)="onShowUnappliedOnlyChanged()" />
		Show Unapplied Only&nbsp;&nbsp;
	</div>

	<slick-grid class="mt-3" [gridOptions]="gridOptions" (onRowSelected)="onRowClicked($event)" (onRowContextMenu)="onRowContextMenu($event)" #paymentsGrid>
		<ng-template let-paymentGridModel
					 slickGridColumnTemplate="QUICKBOOKS_SYNC">
			<quickbooks-icon [quickbooksSyncStatus]="paymentGridModel.quickbooksSyncStatus"
							 mini="true"
							 lockSynced="true"></quickbooks-icon>
		</ng-template>
		<ng-template let-paymentGridModel
					 slickGridColumnTemplate="BUSINESS_CENTRAL_SYNC">
			<business-central-icon [businessCentralSyncStatus]="paymentGridModel.businessCentralSyncStatus"
								   mini="true"
								   lockSynced="true"></business-central-icon>
		</ng-template>
		<ng-template let-paymentsGridModel slickGridColumnTemplate="PAYMENT_DATE">
			{{paymentsGridModel.paymentDate | date:'M/d/yyyy'}}
		</ng-template>
		<ng-template let-paymentsGridModel slickGridColumnTemplate="REFUND">
			{{paymentsGridModel.amountRefunded | currency}}
		</ng-template>
		<ng-template let-paymentModel slickGridColumnTemplate="IS_VOIDED">
			<i *ngIf="paymentModel.isVoided" class=" ms-2 bi bi-x-circle-fill text-danger"></i>
		</ng-template>
	</slick-grid>
</div>

<slick-context-menu #paymentsGridContextMenuRef>
	<slick-context-menu-item (click)="contextMenuDeletePayment()"><i class="bi bi-trash"></i>&nbsp;Delete Payment</slick-context-menu-item>
</slick-context-menu>

<slick-confirm-dialog #deletePaymentConfirmRef>
	Are you sure you want to delete this payment?
</slick-confirm-dialog>
